module.exports = new __parcel__URL__("deadmau5 - Apnea.fd4d7931.m4a").toString();